export default __webpack_public_path__ + "static/media/m_2.7f669480.jpg";